var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"compact":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var open = ref.open;
return [(open)?_c('div',[_c('VideoPlayer',{attrs:{"video-url":_vm.video.videoUrl,"poster-image":_vm.video.videoPreviewUrl}})],1):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }